import React from 'react';
import { BlueLink, YellowButton } from '../buttons';

const Footer = ({ submitTranslation, cancelTranslation, submitAction, cancelAction }) => (
  <div>
    <BlueLink text={cancelTranslation} className="ttu t-mr3" onClick={cancelAction} />
    <YellowButton text={submitTranslation} className="f--2" onClick={submitAction} />
  </div>
);

Footer.defaultProps = {
  submitTranslation: 'Send',
  cancelTranslation: 'Cancel',
  submitAction: null,
  cancelAction: null
};

export default Footer;
